module.exports = __webpack_public_path__ + "img/744.01512fd2.jpg";